import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

interface ScrollPosition {
  scrollY?: number
  scrollX?: number
}

const scrollMemoryMap = new Map<string, ScrollPosition>();

// by default react does not track the scroll position of the page when the back button was executed
// useRouteScrollMemory will provide save and restore function to preserve the scroll position
const useRouteScrollMemory = () => {
  const history = useHistory();

  // tracker variables/refs
  const pathRef = useRef(history.location.pathname);
  const scrollYRef = useRef(window.scrollY);
  const scrollXRef = useRef(window.scrollX);

  // saves the current position and associates it to the location pathname(url)
  const saveScroll = () => {
    scrollMemoryMap.set(pathRef.current, {
      scrollY: scrollYRef.current,
      scrollX: scrollXRef.current
    });
  };

  // restores the saved position of current location
  const restoreScroll = () => {
    const position = scrollMemoryMap.get(pathRef.current);
    window.scrollTo(position?.scrollX || 0, position?.scrollY || 0);
  };

  // handles/tracks the position of scroll
  const handleScrollEvent = () => {
    pathRef.current = history.location.pathname;
    scrollYRef.current = window.scrollY;
    scrollXRef.current = window.scrollX;
  };

  // add listener on mount and remove on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScrollEvent);
    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, []);

  return {
    saveScroll,
    restoreScroll
  };
};

export default useRouteScrollMemory;
